import { render, staticRenderFns } from "./CertificadorBHP.vue?vue&type=template&id=3ee3d7b1&"
import script from "./CertificadorBHP.vue?vue&type=script&lang=ts&"
export * from "./CertificadorBHP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports